import { Link } from "react-router-dom";
import { LogOut, Truck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useDriverMe } from "@/components/auth/DriverGate";

export default function DriverLayout({ children }) {
  const me = useDriverMe();
  return (
    <div className="min-h-screen bg-slate-50" data-testid="driver-layout">
      <header className="h-16 border-b border-slate-200 bg-white sticky top-0 z-20">
        <div className="h-full max-w-xl mx-auto px-4 flex items-center justify-between gap-3">
          <Link to="/driver" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-[#002FA7] grid place-items-center text-white">
              <Truck className="w-5 h-5" strokeWidth={2.4} />
            </div>
            <div>
              <div className="font-bold text-lg leading-tight" style={{ fontFamily: "Outfit" }}>
                Fleet Sheet
              </div>
              <div className="text-[10px] uppercase tracking-wider text-slate-500 truncate max-w-[140px]" data-testid="driver-layout-name">{me?.name || "Driver"}</div>
            </div>
          </Link>
          <Button variant="ghost" size="sm" onClick={me?.signOut} className="text-slate-600" data-testid="driver-sign-out-btn">
            <LogOut className="w-4 h-4 mr-1.5" /> Sign out
          </Button>
        </div>
      </header>
      <main className="max-w-xl mx-auto px-4 py-5 pb-16">{children}</main>
    </div>
  );
}
